import beFetchStylistStripeDashboard from 'actions/stylist/beFetchStylistStripeDashboard.action';
import beSetupStylistStripeAccount from 'actions/stylist/beSetupStylistStripeAccount.action';

import {
  CHANGE_IS_ONLINE,
  CHANGE_IS_OPEN,
  CHANGE_PATCH_TEST,
  CLEAR_COMPLETED_SAVE_SETTINGS,
  CLEAR_ERROR_MESSAGE,
  GET_SALON_ONLINE_SETTINGS_FAILURE,
  GET_SALON_ONLINE_SETTINGS_REQUEST,
  GET_SALON_ONLINE_SETTINGS_SUCCESS,
  GET_SALON_STRIPE_DASHBOARD_FAILURE,
  GET_SALON_STRIPE_DASHBOARD_REQUEST,
  GET_SALON_STRIPE_DASHBOARD_SUCCESS,
  RESTORE_SERVER_DATA,
  SAVE_SALON_ONLINE_SETTINGS_FAILURE,
  SAVE_SALON_ONLINE_SETTINGS_REQUEST,
  SAVE_SALON_ONLINE_SETTINGS_SUCCESS,
  SET_NOSHOW_OR_DEPOSIT_FAILURE,
  SET_NOSHOW_OR_DEPOSIT_REQUEST,
  STYLIST_CATEGORY_CHANGE_IS_ONLINE,
  TOGGLE_EVERYTHING_OFFLINE,
} from 'settings/online-booking/actions';

const initState = () => ({
  settingsData: {
    business_hours: {},
    category_services: [],
    stylist_service_data: {},
    online_booking: false,
    noshow_or_deposit: {},
    ncob_tiny_url: '',
    group_ncob_tiny_url: '',
    group_name: '',
  },
  initialServerData: {
    business_hours: {},
    category_services: [],
    stylist_service_data: {},
    online_booking: false,
    noshow_or_deposit: {},
    ncob_tiny_url: '',
    group_ncob_tiny_url: '',
    group_name: '',
  },
  isFetching: false,
  errorMessage: '',
  areSettingsSaved: false,
  settingStarted: false,
  dashboardUrl: '',
});

function onlineBookingReducer(state = initState(), action) {
  if (action && action.type) {
    switch (action.type) {
      case GET_SALON_ONLINE_SETTINGS_REQUEST: {
        return { ...state, isFetching: true, areSettingsSaved: false };
      }
      case SET_NOSHOW_OR_DEPOSIT_REQUEST: {
        return { ...state, isFetching: true, areSettingsSaved: false };
      }
      case GET_SALON_ONLINE_SETTINGS_SUCCESS: {
        const settingsData = action.response;
        const initialServerData = JSON.parse(JSON.stringify(settingsData));
        // online only exists at frontend, when toggleEverythingOn, it's true, otherwise, it's false
        // it's not set by backend
        // initialServerData.online = state.settingsData.online;

        return {
          ...state,
          isFetching: false,
          settingsData,
          isSettingsDataFetched: true,
          initialServerData,
        };
      }
      case GET_SALON_ONLINE_SETTINGS_FAILURE: {
        return { ...state, isFetching: false, isSettingsDataFetched: true, errorMessage: action.errorMessage };
      }
      case SAVE_SALON_ONLINE_SETTINGS_REQUEST: {
        return { ...state, isFetching: true };
      }
      case SAVE_SALON_ONLINE_SETTINGS_SUCCESS: {
        const { settingsData } = state;
        settingsData.online_booking = action.params.online_booking;
        if (action.response.ncob_tiny_url) {
          settingsData.ncob_tiny_url = action.response.ncob_tiny_url;
        }
        const initialServerData = JSON.parse(JSON.stringify(state.settingsData));

        return {
          ...state,
          isFetching: false,
          initialServerData,
          settingsData,
          areSettingsSaved: true,
          settingStarted: false,
        };
      }
      case SET_NOSHOW_OR_DEPOSIT_FAILURE:
      case SAVE_SALON_ONLINE_SETTINGS_FAILURE: {
        return { ...state, isFetching: false, errorMessage: action.errorMessage };
      }
      case CHANGE_PATCH_TEST: {
        const categories = state.settingsData.category_services.slice();
        let found = false;
        for (let i = 0; i < categories.length; i += 1) {
          if (found) {
            break;
          }
          for (let j = 0; j < categories[i].services.length; j += 1) {
            if (action.id === categories[i].services[j].id) {
              categories[i].services[j].patch_test = action.value;
              found = true;
              break;
            }
          }
        }
        return { ...state, settingsData: { ...state.settingsData, category_services: categories } };
      }
      case CHANGE_IS_OPEN: {
        const businessHours = Object.assign({}, state.settingsData.business_hours);
        businessHours[action.day].is_open = action.value;
        return { ...state, settingsData: { ...state.settingsData, business_hours: { ...businessHours } } };
      }
      case CHANGE_IS_ONLINE: {
        const stylistServiceData = Object.assign({}, state.settingsData.stylist_service_data);
        const stylist = stylistServiceData[action.stylistId];
        const { categories } = stylist;
        const keys = Object.keys(categories);
        let categoryToChange;
        let services;
        let changedServices;
        for (let j = 0; j < keys.length; j += 1) {
          const categoryName = keys[j];
          services = categories[categoryName];

          for (let i = 0; i < services.length; i += 1) {
            if (action.serviceId === services[i].service_id) {
              categoryToChange = categoryName;
              services[i].is_online = action.value;
              changedServices = services;
              break;
            }
          }
        }
        stylistServiceData[action.stylistId].categories[categoryToChange] = changedServices;
        return { ...state, settingsData: { ...state.settingsData, stylist_service_data: { ...stylistServiceData } } };
      }
      case STYLIST_CATEGORY_CHANGE_IS_ONLINE: {
        const stylistServiceData = Object.assign({}, state.settingsData.stylist_service_data);
        const stylist = stylistServiceData[action.stylistId];
        const services = stylist.categories[action.categoryName];
        for (let i = 0; i < services.length; i += 1) {
          services[i].is_online = action.value;
        }
        stylistServiceData[action.stylistId].categories[action.categoryName] = services;
        return {
          ...state,
          settingsData: { ...state.settingsData, stylist_service_data: { ...stylistServiceData } },
          settingStarted: true,
        };
      }
      case CLEAR_ERROR_MESSAGE: {
        return { ...state, errorMessage: '' };
      }
      case [beFetchStylistStripeDashboard.AT.fail]: {
        return (state, { errorMessage }) => ({ ...state, errorMessage });
      }
      case [beSetupStylistStripeAccount.AT.fail]: {
        return (state, { errorMessage }) => ({ ...state, errorMessage });
      }

      case TOGGLE_EVERYTHING_OFFLINE: {
        const settingsData = JSON.parse(JSON.stringify(state.settingsData));
        const days = Object.keys(settingsData.business_hours);
        if (action.dayService === 'day' || action.dayService === 'all') {
          for (let i = 0; i < days.length; i += 1) {
            const day = settingsData.business_hours[days[i]];
            if (day) {
              day.is_open = action.on;
            }
          }
        }
        const stylistIds = Object.keys(settingsData.stylist_service_data);
        // const stylistIds = action.stylistList.map(s => s.id);

        if (action.dayService === 'service' || action.dayService === 'all') {
          for (let i = 0; i < stylistIds.length; i += 1) {
            const stylist = settingsData.stylist_service_data[stylistIds[i]];
            const categoryIds = Object.keys(stylist.categories);
            for (let j = 0; j < categoryIds.length; j += 1) {
              const category = stylist.categories[categoryIds[j]];
              for (let k = 0; k < category.length; k += 1) {
                category[k].is_online = action.on;
              }
            }
          }
        }
        settingsData.online_booking = action.on;
        return { ...state, settingsData };
      }
      case RESTORE_SERVER_DATA: {
        const settingsData = JSON.parse(JSON.stringify(state.initialServerData));
        return { ...state, settingsData };
      }
      case CLEAR_COMPLETED_SAVE_SETTINGS: {
        return { ...state, areSettingsSaved: false };
      }
      case GET_SALON_STRIPE_DASHBOARD_REQUEST: {
        return { ...state, isFetching: true };
      }
      case GET_SALON_STRIPE_DASHBOARD_SUCCESS: {
        return { ...state, isFetching: false, dashboardUrl: action.response.url };
      }
      case GET_SALON_STRIPE_DASHBOARD_FAILURE: {
        return { ...state, isFetching: false, errorMessage: action.errorMessage };
      }
      default:
        return state;
    }
  }
  return state;
}

export default onlineBookingReducer;
